import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Input, Textarea } from '../../../../../../itrust_common/components/form';
import { dateTimeFormat } from '../../../../../../itrust_common/components/HelperFunctions';

const formatDateTime = (val) => {
  if (!val) return '';
  try {
    const formatted = dateTimeFormat(val);
    return formatted === '-' ? '' : formatted;
  } catch (e) {
    return val;
  }
};

let VisionRxOrderForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit} className="px-5 pb-5">
    <div className="row">
      <Field
        name="integration_log_attributes.id"
        label="ID"
        component={Input}
        disabled={true}
        className="form-control"
        wrapperClasses="col-md-6 form-group"
      />
      <Field
        name="integration_log_attributes.last_status_updated_at"
        label="Last Status Updated At"
        component={Input}
        disabled={true}
        className="form-control"
        wrapperClasses="col-md-6 form-group"
      />
      <Field
        name="integration_log_attributes.created_at"
        label="Created At"
        component={Input}
        disabled={true}
        className="form-control"
        wrapperClasses="col-md-6 form-group"
      />
      <Field
        name="message_to_lab"
        label="Message to Lab"
        component={Textarea}
        rows="5"
        className="form-control"
        wrapperClasses="col-12 form-group mb-0"
      />
    </div>
  </form>
);

VisionRxOrderForm = reduxForm({
  enableReinitialize: true,
})(VisionRxOrderForm);

VisionRxOrderForm = connect((state, ownProps) => {
  const labOrder = state.labOrder?.lab_order || state.labOrder || {};
  const integrationLog =
    ownProps?.integrationLogAttributes ||
    labOrder?.integration_log_attributes ||
    labOrder?.integration_log ||
    {};

  return {
    initialValues: {
      message_to_lab: labOrder?.integration_details?.message_to_lab || labOrder?.message || '',
      integration_log_attributes: {
        id: integrationLog?.id !== undefined && integrationLog?.id !== null ? String(integrationLog.id) : '',
        last_status_updated_at: formatDateTime(integrationLog?.last_status_updated_at),
        created_at: formatDateTime(integrationLog?.created_at),
      }
    }
  };
})(VisionRxOrderForm);

export default VisionRxOrderForm;
